import klaxLogo from 'assets/images/klax-auth-logo.png';

export function AuthBrand() {
  return (
    <div className="flex items-center whitespace-nowrap">
      <img
        src={klaxLogo}
        className="h-12 w-12 object-contain"
        alt="KLAX logo"
      />
    </div>
  );
}
